export default {
  blockUi: false,
  filters: {},
  spinner: {
    message: '',
    status: false,
  },
  procedimentoEletronicoCalibracao: '',
  instrumentoCalibracao: '',
  abaKanban: 0,
};
